const Lang = require('lang');

function ModalDespesaInconsistencias() {
  const inconsistencyIcon = $('.data-inconsistency-icon');
  const inconsistencyModal = $('#modal-inconsistencias');

  inconsistencyIcon.on('click', function() {
    const despesasInconsistencias = window.despesasInconsistencias;
    const expenseId = $(this).attr('data-expenses-id');
    const despesaInconsistencias = despesasInconsistencias[expenseId];

    const ul = document.getElementById('modal-inconsistencias-list');

    let itens = '';
    despesaInconsistencias.forEach(inconsistencia => {
      itens += '<li>' + inconsistencia + '</li>';
    });
    ul.innerHTML = itens;

    inconsistencyModal.modal('show');
  });
};

module.exports = {
  init: ModalDespesaInconsistencias,
  url: /\/aprovacoes/
}
